import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { postRiskAssessment } from './api';
import { RiskAssessmentDTO } from './dto/RiskAssessmentDTO';

function usePostRiskAssessment() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (riskAssessment: RiskAssessmentDTO) => postRiskAssessment(riskAssessment),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('riskAssessment');
      },
      onError: error => {
        toast.error(t('message.title.error.post.riskAssessment'));
      },
    }
  );
  return {postRiskAssessment: mutate, isLoadingPostRiskAssessment: isLoading};
}

export default usePostRiskAssessment;
